'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var ReactDOM = require('react-dom');
var _ = require('lodash');
var compose = require('../hoc/compose');
var displayNames = require('./displayNames');
var dropDownHelpers = require('../util/dropDownHelpers');
var dropDownPositionUtil = require('../util/dropDownPosition');

var _require = require('./dropDownChildren'),
    Option = _require.Option,
    Selected = _require.Selected,
    SearchBox = _require.SearchBox;

var KEYS = require('../constants/keyCodes');
var template = require('./dropDown.rt');

var _require2 = require('../util/rect'),
    getRectByBoundingRect = _require2.getRectByBoundingRect,
    getRectByReactElement = _require2.getRectByReactElement;

var wrapOption = dropDownHelpers.wrapOption;


var isSelected = function isSelected(val, curr) {
    return !_.isUndefined(val) && (val === curr || val === (curr && curr.value) || val === _.get(curr, 'props.value'));
};

var wrapOptionWithOptionComponent = wrapOption.bind(null, Option);

var getOptionsValue = function getOptionsValue(opt) {
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';

    if (React.isValidElement(opt)) {
        return opt.props[key];
    }
    return _.isObject(opt) ? opt[key] : opt;
};

var getOptionsLabel = function getOptionsLabel(opt) {
    return getOptionsValue(opt, 'label');
};

var isOptionsDisabled = function isOptionsDisabled(opt) {
    if (React.isValidElement(opt)) {
        return opt.props.disabled;
    }
    return _.isObject(opt) ? opt.disabled : false;
};

var isTermInOption = function isTermInOption(term, opt) {
    var searchable = getOptionsLabel(opt) || getOptionsValue(opt);
    return searchable && _.startsWith(searchable.toLowerCase(), term.toLowerCase());
};

var DropDown = function (_React$Component) {
    _inherits(DropDown, _React$Component);

    function DropDown(props) {
        _classCallCheck(this, DropDown);

        var _this = _possibleConstructorReturn(this, (DropDown.__proto__ || Object.getPrototypeOf(DropDown)).call(this, props));

        var onOptionClick = function onOptionClick(val) {
            _this.props.onChange(val);
            _this.setState({
                isOpen: false,
                candidateIndex: _.indexOf(_this.getOptions(), _this.getSelected())
            });
        };

        _this.getOptions = function () {
            var flatten = _this.props.groupedOptions ? _.flattenDeep : _.flatten;

            var children = _this.props.children && (_.isArray(_this.props.children) ? _this.props.children : [_this.props.children]);

            return _this.props.options || _.compact(flatten(children)) || [];
        };

        _this.findOption = function (val) {
            return _.find(_this.getOptions(), isSelected.bind(null, val));
        };

        _this.hasChildren = function () {
            return React.isValidElement(_this.getOptions());
        };

        _this.map = _this.hasChildren() ? React.Children.map : _.map;

        _this.getSelected = function () {
            return _this.findOption(_this.props.value) || _this.props.placeholder || _this.getOptions()[0];
        };

        _this.onSelectedMount = function (ref) {
            _this.wrappedSelectedOption = ref;
        };

        _this.onActiveUpdate = function (ref) {
            _this.activeOption = ref;
        };

        _this.registerStickyFooter = function (ref) {
            _this.stickyFooter = ref;
        };

        _this.optionsRefs = [];
        _this.optionsY = [];
        _this.onOptionMount = function (index, ref) {
            _this.optionsRefs[index] = ref;
            _this.optionsY[index] = ReactDOM.findDOMNode(ref).offsetTop;
        };

        _this.getOptionsElements = function () {
            return _this.map(_this.getOptions(), function (opt, index) {
                return wrapOptionWithOptionComponent({
                    onClick: onOptionClick,
                    // TODO: Performance improvement: Use candidateIndex state only for keys (UP/DOWN) and use hover and click for mouse
                    onMouseEnter: function onMouseEnter() {
                        return _this.setState({ candidateIndex: index });
                    },
                    shouldTranslate: _this.props.shouldTranslate,
                    selected: _this.getSelected() === opt,
                    active: index === _this.state.candidateIndex,
                    onSelectedMount: _this.onSelectedMount,
                    onActive: _this.onActiveUpdate,
                    key: opt.key || opt.value || opt,
                    onMount: _this.props.shouldPassIsVisibleToOptions ? function (ref) {
                        _this.onOptionMount(index, ref);
                    } : _.noop,
                    isVisible: _this.props.shouldPassIsVisibleToOptions ? _.includes(_this.state.visibleOptionsIndexes, index) : null,
                    wasVisible: _this.props.shouldPassIsVisibleToOptions ? _.includes(_this.state.wasVisibleOptionsIndexes, index) : null,
                    registerStickyFooter: _this.registerStickyFooter
                }, opt);
            });
        };

        _this.getCloseKeys = function () {
            return _this.props.searchBox ? [KEYS.ENTER, KEYS.ESC] : null;
        };

        _this.searchOption = function (term) {
            return _.find(_this.getOptions(), function (opt) {
                return isTermInOption(term, opt) && _this.getIsSelectableByIndex(_this.getOptions().indexOf(opt));
            });
        };

        _this.onSearch = function (searchTerm, callback) {
            var foundOption = searchTerm && _this.searchOption(searchTerm);
            var candidateIndex = foundOption ? _this.getOptions().indexOf(foundOption) : _this.state.candidateIndex;
            _this.setState({
                candidateIndex: candidateIndex,
                foundOption: foundOption,
                searchTerm: searchTerm
            }, function () {
                var enforce = true;
                _this.scrollToActive(enforce);
                if (_.isFunction(callback)) {
                    callback();
                }
            });
        };

        _this.registerInputToAllowEvents = function (input) {
            _this.setState({ inputToAllowEvents: input });
        };

        _this.getSelectedElements = function () {
            var selected = _this.getSelected();
            var _this$props = _this.props,
                hasArrowIcon = _this$props.hasArrowIcon,
                shouldTranslate = _this$props.shouldTranslate;

            var shouldRenderSearchBox = _this.props.searchBox && _this.state.isOpen;

            var key = void 0;
            var child = void 0;
            if (React.isValidElement(selected)) {
                key = selected.key;
                child = shouldRenderSearchBox ? selected.props.label || selected.props.value : selected;
            } else if (selected) {
                var isStringValue = _.isString(selected);
                key = isStringValue ? selected : selected.key || selected.label || selected.value;
                child = isStringValue ? selected : selected.label || selected.value;
            }

            if (shouldRenderSearchBox) {
                return React.createElement(SearchBox, {
                    key: key,
                    hasArrowIcon: hasArrowIcon,
                    shouldTranslate: shouldTranslate,
                    value: getOptionsLabel(_this.state.foundOption) || _this.state.searchTerm,
                    searchTerm: _this.state.searchTerm,
                    selectedValue: child,
                    onChange: _this.onSearch,
                    registerInputToAllowEvents: _this.registerInputToAllowEvents
                });
            }

            return React.createElement(Selected, { key: key, hasArrowIcon: hasArrowIcon, shouldTranslate: shouldTranslate }, child);
        };

        _this.toggleOptions = function (isOpen) {
            return _this.setState({ isOpen: _.isUndefined(isOpen) ? !_this.state.isOpen : isOpen });
        };
        _this.state = {
            isOpen: false,
            optionsStyle: {},
            optionsInnerStyle: {},
            visibleOptionsIndexes: [],
            wasVisibleOptionsIndexes: [],
            candidateIndex: _.indexOf(_this.getOptions(), _this.getSelected()),
            searchTerm: null
        };

        _this.getValueByIndex = function (index) {
            return getOptionsValue(_this.getOptions()[index]);
        };
        _this.getIsDisabledByIndex = function (index) {
            return isOptionsDisabled(_this.getOptions()[index]);
        };
        _this.getIsSelectableByIndex = function (index) {
            return !(_.isUndefined(_this.getValueByIndex(index)) || _this.getIsDisabledByIndex(index));
        };

        _this.getNewIndex = function (by) {
            var index = _this.state.candidateIndex;
            var originalIndex = index;
            var min = 0;
            var max = _this.getOptions().length - 1;

            do {
                index += by;
            } while (!_this.getIsSelectableByIndex(index) && index >= 0 && index <= max);

            return index === max + Math.abs(by) || index === min - Math.abs(by) ? originalIndex : index;
        };

        _this.scrollOptionsNode = function (optionsNode, deltaY) {
            if (!_this.customBlockScroll(optionsNode, deltaY)) {
                optionsNode.scrollTop += deltaY;
            }
        };

        _this.scrollToActive = function (enforce) {
            if (_this.activeOption) {
                var activeNode = ReactDOM.findDOMNode(_this.activeOption);
                var optionsNode = activeNode.parentElement;

                if (enforce) {
                    optionsNode.scrollTop = activeNode.offsetTop;
                }

                var optionsScrollTop = optionsNode.scrollTop;
                var activeNodeBottom = activeNode.offsetTop + activeNode.offsetHeight;

                var visibleBottom = optionsScrollTop + optionsNode.offsetHeight;
                if (activeNodeBottom > visibleBottom) {
                    _this.scrollOptionsNode(optionsNode, activeNodeBottom - visibleBottom);
                } else if (activeNode.offsetTop < optionsScrollTop) {
                    _this.scrollOptionsNode(optionsNode, activeNode.offsetTop - optionsScrollTop);
                }
            }
        };

        _this.onKeyDown = function (e, isOpen) {
            if (isOpen) {
                if (e.keyCode === KEYS.UP || e.keyCode === KEYS.DOWN) {
                    var incrementBy = e.keyCode === KEYS.UP ? -1 : 1;
                    _this.setState({ candidateIndex: _this.getNewIndex(incrementBy) }, _this.scrollToActive);
                } else if (e.keyCode === KEYS.ENTER || e.keyCode === KEYS.SPACE && !_this.props.searchBox) {
                    _(_this.state.candidateIndex).thru(_this.getValueByIndex).thru(_this.props.onChange).value();
                }
            }
        };

        var updateScrollCache = function updateScrollCache(optionsNode, deltaY) {
            var remainingScroll = optionsNode.scrollHeight - optionsNode.offsetHeight;
            _this.scrollCache += Math.min(Math.abs(deltaY), remainingScroll);
            _this.onOptionsLayoutChange(_this.lastOptionsBoundingRect, optionsNode);
        };

        _this.scrollCache = 0;
        _this.customBlockScroll = function (optionsNode, deltaY) {
            // TODO: Pick better name
            if (_this.props.searchBox) {
                return false;
            }

            var optionsRect = optionsNode.getBoundingClientRect();
            var remainingScroll = optionsNode.scrollHeight - optionsNode.offsetHeight;
            var indentFromEdge = dropDownPositionUtil.CONSTS.INDENT_FROM_EDGE;
            var maxAllowedHeight = dropDownPositionUtil.getViewportSize().height - indentFromEdge * 2;

            if (optionsNode.offsetHeight < maxAllowedHeight && remainingScroll > 0) {
                if (deltaY > 0 && optionsRect.top > indentFromEdge) {
                    updateScrollCache(optionsNode, deltaY);
                    return true;
                } else if (deltaY < 0 && optionsRect.bottom < maxAllowedHeight + indentFromEdge) {
                    updateScrollCache(optionsNode, deltaY);
                    return true;
                }
            }
        };

        _this.onOptionsScroll = function (e) {
            if (_this.props.shouldPassIsVisibleToOptions) {
                var OFFSET = 30;
                var scrollTop = e.target.scrollTop;

                var height = _this.state.optionsInnerStyle.height || _this.state.optionsStyle.height;
                var visibleOptionsIndexes = _(_this.optionsY).map(function (y, i) {
                    return scrollTop - OFFSET < y && y < scrollTop + height + OFFSET ? i : null;
                }).filter(function (i) {
                    return i !== null;
                }).value();

                var wasVisibleOptionsIndexes = _.union(_this.state.wasVisibleOptionsIndexes, visibleOptionsIndexes);

                _this.setState({
                    visibleOptionsIndexes: visibleOptionsIndexes,
                    wasVisibleOptionsIndexes: wasVisibleOptionsIndexes
                });
            }
        };

        _this.getHiddenScrollStyle = function (optionsNode) {
            var scrollBarWidth = optionsNode.offsetWidth - optionsNode.clientWidth;
            return {
                width: 'calc(100% + ' + scrollBarWidth + 'px)'
            };
        };

        _this.onOptionsLayoutChange = function (optionsBoundingRect, optionsNode) {
            if (!optionsBoundingRect) {
                _this.scrollCache = 0;
            }
            _this.lastOptionsBoundingRect = optionsBoundingRect;
            if (optionsBoundingRect) {
                var viewport = dropDownPositionUtil.getViewportSize();
                var selectedRect = getRectByReactElement(_this);
                var optionsRect = getRectByBoundingRect(optionsBoundingRect);
                var selectedOptionsNode = _this.wrappedSelectedOption ? ReactDOM.findDOMNode(_this.wrappedSelectedOption) : null;
                var selectedOptionY = !_this.props.searchBox && _this.props.openOnSelected && selectedOptionsNode ? selectedOptionsNode.offsetTop || 0 : null;
                var params = { longerByScroll: _this.scrollCache, selectedOptionY: selectedOptionY };
                var optionsPosition = dropDownPositionUtil.getOptionsPosition(viewport, selectedRect, optionsRect, params);

                var stickyFooterHeight = _this.stickyFooter ? ReactDOM.findDOMNode(_this.stickyFooter).offsetHeight : null;
                var stickyFooterStyle = stickyFooterHeight ? { height: optionsPosition.height - stickyFooterHeight } : {};
                var hiddenScrollStyle = _this.props.hiddenScroll && !_this.props.searchBox ? _this.getHiddenScrollStyle(optionsNode) : {};

                _this.setState({
                    optionsStyle: {
                        top: optionsPosition.y,
                        left: optionsPosition.x,
                        height: optionsPosition.height,
                        width: optionsPosition.width
                    },
                    optionsInnerStyle: _.assign(hiddenScrollStyle, stickyFooterStyle)
                }, function () {
                    var selectedOptionsRect = selectedOptionsNode ? getRectByBoundingRect(selectedOptionsNode.getBoundingClientRect()) : {};
                    var shouldAutoScroll = !_this.scrollCache && selectedOptionY > 0 && optionsNode.scrollTop === 0 && selectedRect.y !== selectedOptionsRect.y;
                    if (shouldAutoScroll) {
                        optionsNode.scrollTop = selectedOptionsRect.y - selectedRect.y;
                    }
                });
            }
        };

        _this.getOptionsContainerClassName = function () {
            return _.compact([_this.props.optionsContainerClassName, _this.props.hiddenScroll && !_this.props.searchBox ? 'hidden-scroll' : null, dropDownPositionUtil.getViewportSize().width <= dropDownPositionUtil.CONSTS.NARROW_VIEWPORT ? 'narrow-viewport' : null]).join(' ');
        };
        return _this;
    }

    _createClass(DropDown, [{
        key: 'render',
        value: function render() {
            return template.call(this);
        }
    }]);

    return DropDown;
}(React.Component);

DropDown.displayName = displayNames.DROP_DOWN;

DropDown.propTypes = {
    disabled: React.PropTypes.bool,
    value: React.PropTypes.any,
    options: dropDownHelpers.PropTypes.options,
    onChange: React.PropTypes.func,
    hasArrowIcon: React.PropTypes.bool,
    hiddenScroll: React.PropTypes.bool,
    openOnSelected: React.PropTypes.bool,
    searchBox: React.PropTypes.bool,
    shouldPassIsVisibleToOptions: React.PropTypes.bool,
    optionsContainerClassName: React.PropTypes.string,
    groupedOptions: React.PropTypes.bool,
    placeholder: React.PropTypes.oneOfType([React.PropTypes.string.isRequired, React.PropTypes.element.isRequired])
};

DropDown.defaultProps = {
    disabled: false,
    hasArrowIcon: true,
    hiddenScroll: true,
    openOnSelected: true,
    searchBox: false,
    shouldPassIsVisibleToOptions: false,
    groupedOptions: false,
    optionsContainerClassName: ''
};

module.exports = compose(DropDown);


// WEBPACK FOOTER //
// ./~/wix-base-ui/lib/controls/dropDown.js